export type PageHeroPhoto = {
  src: string
  alt: string
}

export const pageHeroPhotos: Record<
  'eastEndWay' | 'specials' | 'financing' | 'reviews' | 'contact',
  PageHeroPhoto
> = {
  eastEndWay: {
    src: 'https://cdn.magicpatterns.com/uploads/5WzEpQm6uydgEpREwEgAU3/1000012135.jpg',
    alt: 'Illuminated East End Automotive Repair sign and gear logo on the shop building at dusk in Oak Ridge, Tennessee.',
  },
  specials: {
    src: 'https://cdn.magicpatterns.com/uploads/qp8MCYZYr5X3UJ2Wue6tnJ/1000012136.jpg',
    alt: 'East End Automotive Repair building with lit service bays and a customer vehicle parked outside at dusk.',
  },
  financing: {
    src: 'https://cdn.magicpatterns.com/uploads/uiHzBAEtRmwrcbdYzfXz9L/1000012138.jpg',
    alt: 'Customer SUV with headlights on parked in front of the lit East End Automotive Repair shop at twilight.',
  },
  reviews: {
    src: 'https://cdn.magicpatterns.com/uploads/nQJJ3kWFeihdeHWufCQK5E/1000012142.jpg',
    alt: 'East End Automotive Repair wall sign glowing above a customer vehicle parked at the shop after hours.',
  },
  contact: {
    src: 'https://cdn.magicpatterns.com/uploads/3Y6hytXDBise9T2UmkSvS8/1000012143.jpg',
    alt: 'East End Automotive Repair roadside sign with the shop phone number and the service bays behind it on a clear day.',
  },
}
